import * as React from 'react';

import styles from './CalendarPickerPlaceholder.scss';

export function renderCalendarPickerPlaceholder(): JSX.Element {
    return <div className={styles.container}>&nbsp;</div>;
}
